import React from "react";

const MessageScreen: React.FC = React.memo((props) => {
  return <div>首页</div>;
});

export default MessageScreen;
